{
	"title": "Comentarii",
	"statuses": {
		"inValidation": "In validare",
		"rejected": "Respins",
		"assured": "Confirmat",
		"flagged": "Semnalat",
		"resolved": "Rezolvat"
	}
}
